import React from 'react';
import { Link } from 'react-router-dom';

export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="d-flex flex-wrap align-items-start justify-content-between gap-3 mb-4">
      <div>
        <h1 className="h3 mb-1 text-dark">{title}</h1>
        {subtitle ? <p className="text-secondary mb-0">{subtitle}</p> : null}
      </div>
      <div className="d-flex flex-wrap gap-2">{actions}</div>
    </div>
  );
}

export function Card({ children, className = '' }) {
  return <div className={`card shadow-sm border-0 ${className}`.trim()}>{children}</div>;
}

export function CardBody({ children, className = '' }) {
  return <div className={`card-body ${className}`.trim()}>{children}</div>;
}

export function ErrorBanner({ message }) {
  if (!message) return null;
  return (
    <div className="alert alert-danger" role="alert">
      {message}
    </div>
  );
}

export function BackLink({ to, children }) {
  return (
    <Link to={to} className="btn btn-link text-decoration-none ps-0 mb-3">
      ← {children || 'Back'}
    </Link>
  );
}
